import { CircuitBreaker } from './circuitBreaker.js';
const store = new Map();
export function getCircuitBreaker(hash, settings) {
    if (store.has(hash)) {
        const circuitBreaker = store.get(hash);
        circuitBreaker.setConfig(settings);
        return circuitBreaker;
    }
    const circuitBreaker = new CircuitBreaker(settings);
    store.set(hash, circuitBreaker);
    return circuitBreaker;
}
export function getCircuitBreakerSize() {
    return store.size;
}
export function getHashes() {
    return Array.from(store.keys());
}
//# sourceMappingURL=circuitBreakersStore.js.map